import React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Checkbox as CheckboxMUI } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import { makeStyles } from 'tss-react/mui'
import { TObject } from 'utils/types'

export interface ICheckboxFieldProps {
  name?: string
  label: string
  checked?: boolean
  disabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  formControlStyles?: TObject
  color?: 'primary' | 'secondary' | 'default'
  labelColor?: string
  inputRef?: React.Ref<any>
  [key: string]: any
}

export const Checkbox: React.FC<ICheckboxFieldProps> = ({
  name,
  label,
  checked,
  disabled = false,
  onChange,
  formControlStyles = {},
  color = 'primary',
  labelColor,
  inputRef,
  ...rest
}) => {
  const { classes } = useStyles({ labelColor })

  return (
    <FormControl style={formControlStyles}>
      <FormControlLabel
        control={
          <CheckboxMUI
            name={name}
            checked={checked !== undefined ? checked : false}
            onChange={onChange}
            disabled={disabled}
            color={color}
            classes={{ root: classes.checkbox }}
            inputRef={inputRef}
            {...rest}
          />
        }
        label={label}
        className={classes.formControlLabel}
        componentsProps={{
          typography: {
            style: {
              color: labelColor,
              marginLeft: 8, // можно добавить отступ между текстом и чекбоксом
            },
          },
        }}
      />
    </FormControl>
  )
}

const useStyles = makeStyles<{ labelColor?: string }>()((theme, { labelColor }) => ({
  checkbox: {
    color: labelColor || theme.palette.text.primary,
    '&.Mui-checked': {
      color: labelColor || theme.palette.primary.main,
    },
  },
  formControlLabel: {
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    justifyContent: 'space-between',
    '& .MuiTypography-root': {
      flex: 1,
      fontSize: '1rem', // при необходимости задай размер текста
    },
  },
}))
